"use strict";

// eslint-disable-next-line max-lines-per-function
export const getDefaultState = () => {
  return {
    currentUser: null,
    isVerifyingSession: false,
    isSessionVerified: false,
    sessionVerifyError: null,
    isAuthSuccessRedirecting: false,
    isAuthFailedRedirecting: false,
    isAuthenticating: false,
    isPendingAccountCreation: false,
    pendingAccountEmail: null,
    pendingAccountProfile: null,
    registrationToken: null,
    isPendingAccountLinking: false,
    pendingAccountLinkingProfile: null,
    accountLinkingToken: null,
    accountLinkingError: null,
    accountLinkingInvalidPassword: false,
    isOngoingAccountLinking: false,
    isOngoingRegistration: false,
    registrationError: null,
    socialSigninWindow: null,
    socialWindowManuallyClosed: false,
    socialListener: null,
    isRedirectingSocialSignIn: false,
    selectedSocialConnection: null,
    isOngoingSocialSignIn: false,
    socialSignInError: null,
    isLoadingSSOProfile: false,
    isSSOProfileLoaded: false,
    authKey: null,
    authRedirectUri: null,
    authToken: null,
    mfaToken: null,
    nonce: null,
    preferredChannel: "sms",
    userDetails: {
      phone: null,
      email: null,
    },
    challengeSuccess: false,
    isMfaRequired: false,
    mfaExpiresAt: null,
    mfaNextResend: null,
    isRequestingChallenge: false,
    isVerifyingMfaCode: false,
    invalidMfaCode: false,
    validMfaCode: false,
    authenticationError: null,
    verifyMfaError: null,
    challengeError: null,
    errorReference: null,
    isTemporaryBlocked: false,
    temporaryBlockedTime: null,
    isBlocked: false,
    errorMessage: null,
    remainingAttempts: 0,
    isPendingAccountVerification: false,
    verificationProfile: null,
    isResendingVerification: false,
    resendVerificationError: null,
    isChangingRegistrationEmail: false,
    changeRegistrationEmailError: null,
    isVerifyingAccount: false,
    verifyAccountError: null,
    verifiedLoginRequired: false,
  };
};

export const state = getDefaultState();
